module.exports = __webpack_public_path__ + "img/unity.91599129.png";